var Utils = {}

// --- constants --- //
Utils.phi = (Math.sqrt(5)-1) * 0.5

// --- //

// can't spell boilerplate with out lerp!
Utils.lerp = (from, to, pct) => {
  return ((to - from) * pct) + from
}

// --- //
Utils.listToDict = (list, uniqueProp = 'id') => {
  var dict = {}
  list.forEach(element => {
    dict[element[uniqueProp]] = element
  })

  return dict
}
/*
Utils.formatDate = (date) => {
  var dateString = ''
  date.get
}
*/

// --- color utils --- //
/*
		               -- HUE -- 
                                   m
           y                       a
           e     g                 g      
           l     r     c     b     e      
     r     l     e     y     l     n     r
		 e     o     e     a     u     t     e      RGB channel %
		 d     w     n     n     e     a     d       |
		 |     |     |     |     |     |     |       v
		                                             
  --| --R--.-----G-----.-----B-----.--R-- |-- - 1.0
		|     / \         / \         / \     |
		|    /   \       /   \       /   \    |
		|   G     R     B     G     R     B   |   - 0.5
		|  /       \   /       \   /       \  |
		| /         \ /         \ /         \ |
	--|._____B_____V_____R_____V_____G_____.|-- - 0.0

		 |     |     |     |     |     |     |
		 |     |     1     1     2     3     3
		 |     6     2     8     4     0     6  <- degrees
		 0     0     0     0     0     0     0

*/

Utils.hslToRgb = (h, s, l) => {
  h = (h*6) % 6 // from 0->1 to 0->6 indexed by the RGB color wheel
  let chroma = (1 - Math.abs(2*l - 1) ) * s
	let x = chroma * (1 - Math.abs( h%2 - 1 ))
	let min = l - chroma * 0.5
	
	let r = min
	let g = min
	let b = min
  
	if (h < 1){
		r += chroma
		g += x
	}else if(h < 2){
		g += chroma
		r += x
	}else if(h < 3){
		g += chroma
		b += x
	}else if(h < 4){
		b += chroma
		g += x
	}else if(h < 5){
		b += chroma
		r += x
	}else{
		r += chroma
		b += x
	}
	
	r *= 255
	g *= 255
	b *= 255
	
	//trace("r:"+r+" g:"+g+" b:"+b)
	let roundoffErrorCorrection = 0.0000000000001
	
	r = Math.floor(r + roundoffErrorCorrection)
	g = Math.floor(g + roundoffErrorCorrection)
	b = Math.floor(b + roundoffErrorCorrection)
	
	//trace("r:"+r+" g:"+g+" b:"+b)
	
	let hexColor = "#"
	hexColor += r.toString(16)
	hexColor += g.toString(16)
	hexColor += b.toString(16)
  return hexColor
}

Utils.hsvToRgb = (h, s, v) => {
  h = (h*6) % 6 // from 0->1 to 0->6 indexed by the RGB color wheel
  let chroma = v * s
	let x = chroma * (1 - Math.abs( h%2 - 1 ))
	let min = v - chroma
	
	let r = min
	let g = min
	let b = min
	
	if (h < 1){
		r += chroma
		g += x
	}else if(h < 2){
		g += chroma
		r += x
	}else if(h < 3){
		g += chroma
		b += x
	}else if(h < 4){
		b += chroma
		g += x
	}else if(h < 5){
		b += chroma
		r += x
	}else{
		r += chroma
		b += x
	}

	r *= 255
	g *= 255
	b *= 255
	
	//trace("r:"+r+" g:"+g+" b:"+b)
	let roundoffErrorCorrection = 0.0000000000001
	
	r = Math.floor(r + roundoffErrorCorrection)
	g = Math.floor(g + roundoffErrorCorrection)
	b = Math.floor(b + roundoffErrorCorrection)
	
	//trace("r:"+r+" g:"+g+" b:"+b)
	
	let hexColor = "#"
	hexColor += r.toString(16)
	hexColor += g.toString(16)
	hexColor += b.toString(16)
  return hexColor
}

// TODO: BIG make this color blind friendly!!! 
Utils.getPlayerColors = (playerCount, uuid, s=1, v=1) => {
  let hexText = uuid.slice(-2)
  hexText = '0x'+hexText
  let hexSeed = parseInt(hexText)
  let colors = []
  for (var i=0; i<playerCount; i++) {
    let h = (Utils.phi * (hexSeed+i)) % 1
    colors.push(Utils.hsvToRgb(h, s, v))
  }
  return colors
}


// TODO: split utils by concern eg, ColorUtils ObjectUtils

Utils.clone = (obj) => {
	return JSON.parse(JSON.stringify(obj))
}

Utils.pathTextToPathArray = (pathTxt) => {
	return pathTxt.split('.')
}

Utils.getParentRefByPathArray = (obj, path) => {  
	// So .reduce steps through an array calling a function and keeping a running tally (collector, value) 
	//  we step through the object path array using the collector to keep the object reference.
	//  We provide valClone as the initial value for ref, then step down through that object
	//  if we get to an undefined key we make it an empty object. 
	//  (This shouldn't happen in our usage but is good for a more general case.)
	//  we know everything upto the leaf node will be either an object or an array so will be a reference.
	//  The leaf node will often be a primitive so we stop just short. 
	//  Then set the ref to the val, save to state, and Bob's yer uncle.
	let pathClone = Utils.clone(path)
	let leafKey = pathClone.pop()
	let ref = pathClone.reduce((refStep, key) => (refStep || {})[key], obj)
	return {ref, leafKey}
}

Utils.getByPathArray = (obj, path) => {
	// TODO: can't add an object in the path when reading
	let pRef = Utils.getParentRefByPathArray(obj, path)
	return pRef.ref[pRef.leafKey]
}

Utils.setByPathArray = (obj, path, val) => {
	let pRef = Utils.getParentRefByPathArray(obj, path)
	pRef.ref[pRef.leafKey] = val
	return obj // needed?
}

// --- //

Utils.getCoordsByEle = (ele, refEle) => {
	let domRect = ele.getBoundingClientRect()
	let refDomRect = refEle.getBoundingClientRect()
	domRect.x -= refDomRect.x
	domRect.y -= refDomRect.y
	domRect.left -= refDomRect.x
	domRect.top -= refDomRect.y
	domRect.right -= refDomRect.x
	domRect.bottom -= refDomRect.y
	return domRect
}

Utils.getCoordsById = (eleId, refEleId) => {
	let ele = document.getElementById(eleId)
	let refEle = document.getElementById(refEleId)
	return Utils.getCoordsByEle(ele, refEle)
}

// --- //

export default Object.freeze(Utils)
